// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1o4W{margin:1.6rem 0 0}._17JB{display:flex;justify-content:space-between;flex-direction:column}@media (min-width:48em){._17JB{flex-direction:row}}._10yE{flex-grow:1}@media (min-width:48em){._10yE p{max-width:420px}}.ZssU{max-width:200px;margin:1.6rem auto 0;display:block}@media (min-width:48em){.ZssU{margin:auto}}._2d7N{margin:0 0 2.4rem;display:flex;align-items:center;flex-wrap:wrap}@media (min-width:62em){._2d7N{flex-wrap:nowrap}}._2d7N ._1Q6e{width:480px;margin:.8rem 0;padding:.8rem 2rem;text-align:center}@media (min-width:62em){._2d7N ._1Q6e{margin:.8rem 2rem .8rem 0}}@media (min-width:48em){._2d7N ._2RKG{width:32rem}}._38h3{width:100%;display:flex;flex-wrap:wrap;justify-content:space-between}@media (min-width:36em){._38h3{justify-content:flex-start}}@media (min-width:62em){._38h3{width:auto;flex:1}}@media (min-width:62em){html[dir=rtl] ._2d7N ._1Q6e{margin:.8rem 0 .8rem 2rem}}", ""]);
// Exports
exports.locals = {
	"header": "_1o4W",
	"wrapp": "_17JB",
	"content": "_10yE",
	"image": "ZssU",
	"btnWrapp": "_2d7N",
	"btn": "_1Q6e",
	"btn__small": "_2RKG",
	"iconsWrapp": "_38h3"
};
module.exports = exports;
